/**
 * 广告路由配置模块 API
 * 对接 ad-router 服务 /api/v1/configs/landing_pages
 *
 * 数据模型（与 ad-router api.md 保持一致）：
 *   AdConfig: { id, name, ad_id, source_code, country, province, isp, device,
 *               priority, status, start_time, end_time, routes: AdRoute[] }
 *   AdRoute:  { id, name, city, city_list, target_url, priority, weight, status }
 */
import { request } from "@/utils/request";

const AD_BASE = "https://ad-router.intbull.com";

function adUrl(path) {
  return AD_BASE + path;
}

function buildQuery(params) {
  const q = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v != null && v !== "") q.set(k, String(v));
  }
  const s = q.toString();
  return s ? "?" + s : "";
}

/** 查询广告配置列表 */
export function listAdConfigs(params = {}) {
  return request(adUrl(`/api/v1/configs/landing_pages${buildQuery(params)}`));
}

/** 查询广告配置详情 */
export function getAdConfig(id) {
  return request(adUrl(`/api/v1/configs/landing_pages/${id}`));
}

/** 创建广告配置 */
export function createAdConfig(data) {
  return request(adUrl("/api/v1/configs/landing_pages"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}

/** 更新广告配置（整份替换，需带完整 routes） */
export function updateAdConfig(id, data) {
  return request(adUrl(`/api/v1/configs/landing_pages/${id}`), {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}

/** 删除广告配置 */
export function deleteAdConfig(id) {
  return request(adUrl(`/api/v1/configs/landing_pages/${id}`), {
    method: "DELETE",
  });
}

/** 启用广告配置 */
export function enableAdConfig(id) {
  return request(adUrl(`/api/v1/configs/landing_pages/${id}/enable`), {
    method: "POST",
  });
}

/** 禁用广告配置 */
export function disableAdConfig(id) {
  return request(adUrl(`/api/v1/configs/landing_pages/${id}/disable`), {
    method: "POST",
  });
}
